import './cases.component.scss'

// move btn
const mediaQuery = window.matchMedia('(max-width: 768px)')
const section = document.querySelector('.cases__top')
const container = document.querySelector('.cases__container')

if (section) {
	const btn = section.querySelector('.cases__btn')

	if (btn) {
		function handleTabletChange(e) {
			if (e.matches) {
				container.appendChild(btn)
			} else {
				section.insertAdjacentElement('beforeend', btn)
			}
		}
		handleTabletChange(mediaQuery)

		mediaQuery.addEventListener('change', handleTabletChange)
	}
}
